import React from "react";
import { useShoppingContext } from "../../../../context/ShoppingContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus } from "@fortawesome/free-solid-svg-icons";
import AddControlAvesForm from "../../Forms/AddControlAvesForm/AddControlAvesForm";

const ReduceAves = () => {
  const { setShowAddControlAves, showAddControlAves } =
    useShoppingContext();
  return (
    <div className="text-center">
      <button
        className={"w-100 btn btn-green"}
        onClick={() => {
          setShowAddControlAves(!showAddControlAves);
        }}
      >
        <FontAwesomeIcon icon={faMinus} /> Reducir aves
      </button>
      {showAddControlAves && <AddControlAvesForm />}
    </div>
  );
};

export default ReduceAves;
